<div class="detail-user">
	<label [for]="label" class="font-bold text-sm">{{ label }}</label>

	@if (!isEditing()) {
		<p-button type="button"
				  [icon]="editable ? 'pi pi-pen-to-square' : ''"
				  styleClass="btn-text"
				  iconPos="right"
				  variant="outlined"
				  [label]="displayValue"
				  [disabled]="!editable"
				  (click)="startEdit()" />
	}

	<!-- EDIT -->
	@if (isEditing()) {
		<div class="flex gap-2">
			@switch (type) {
				@case ('text') {
					<div class="flex flex-column w-full gap-2">
						<input type="text"
							   pInputText
							   pSize="small"
							   [id]="label"
							   [value]="draftValue()"
							   [pAutoFocus]="true"
							   (keydown.enter)="onSave()"
							   (keydown.escape)="handleEscape($event)"
							   (input)="updateDraft($any($event.target).value)" />
					</div>
				}
				@case ('date') {
					<input [id]="label"
						   type="date"
						   [value]="draftValue()"
						   (input)="updateDraft($any($event.target).value)" />
				}
				@case ('select') {
					<p-select [id]="label"
							  [options]="options"
							  optionLabel="label"
							  optionValue="value"
							  appendTo="body"
							  (onChange)="updateDraft($event.value)"  />
				}
			}

			<div class="flex gap-2">
				<p-button variant="outlined"
						  icon="pi pi-check"
						  (click)="onSave()"
						  size="small"
						  severity="primary" />
				<p-button variant="outlined"
						  icon="pi pi-times"
						  (click)="onCancel()"
						  size="small"
						  severity="danger"/>
			</div>
		</div>
	}
</div>
